import { sendGAEvent } from '../../../domain/marketing/gtm-provider';

interface IProductListPricingAreaSbsBtn {
    skuId: number;
    documentName: string;
    setShowSubscriptionPopup?: Function;
    classes?: string;
}

const ProductListPricingAreaSbsBtn = ({
                                          skuId,
                                          documentName,
                                          setShowSubscriptionPopup,
                                          classes,
}: IProductListPricingAreaSbsBtn) => {

    const sendGoogleEvents = () => {
        sendGAEvent('Subscribe', documentName);

    };

    const openPopup = () => {
        sendGoogleEvents();

        if(!setShowSubscriptionPopup) return;

        setShowSubscriptionPopup(true);
    };

    // const url = `/subscriptions?skus=${ skuId }`;

    return (
        <>
                <button
                    type="button"
                    className={ classes }
                    onClick={ openPopup }>
                    Subscribe
                </button>
        </>
    )
};

export default ProductListPricingAreaSbsBtn;